<br/>
<div class="p-grid">
  <div class="p-col-12">
    <h4>Tree Type Maintenance</h4>
  </div>
</div>
<br/>
<form id="treeTypeMaintenanceForm" #treeTypeMaintenanceForm="ngForm">
  <div class="p-grid">
    <div class="p-col-12 p-lg-6">
      <h6>Common Name</h6>
      @if (treeType) {
        <input pInputText fluid #commonNameInput required name="commonName" [(ngModel)]="treeType.commonName" />
      }
    </div>
    <div class="p-col-12 p-lg-2">
      <h6>Genus</h6>
      @if (treeType) {
        <input pInputText fluid required name="genus" [(ngModel)]="treeType.genus" />
      }
    </div>
    <div class="p-col-12 p-lg-2">
      <h6>Species</h6>
      @if (treeType) {
        <input pInputText fluid required name="species" [(ngModel)]="treeType.species"  />
      }
    </div>
    <div class="p-col-12 p-lg-2 push-contents-to-bottom">
      <p-button
        type="submit"
        (click)="save(treeTypeMaintenanceForm)"
        severity="success"  
        [disabled]="saving"
        label="Save">
      </p-button>
      <p-button 
        type="button"
        severity="warn"  
        (click)="clear(treeTypeMaintenanceForm)"
        label="Clear">
      </p-button>
    </div>
    <div class="p-col-12 columnPadding">
      @if (treeTypeMaintenanceForm.invalid && treeTypeMaintenanceForm.submitted) {
        <div class="alert alert-danger" role="alert">
          There are errors on this page. Please correct the errors and resubmit.
        </div>
      }
    </div>
  </div>
</form>
<br/>
<br/>
<p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="treeTypes" [paginator]="true" [rows]="30" sortField="commonName">
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [style.width]="col.width">
          {{col.header}}
          @if (col.header != '') {
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-treeType let-columns="columns">
    <tr>
      <td><span class="p-column-title">{{columns[0].header}}</span>{{treeType.commonName}}</td>
      <td><span class="p-column-title">{{columns[1].header}}</span>{{treeType.genus}}</td>
      <td><span class="p-column-title">{{columns[2].header}}</span>{{treeType.species}}</td>
      <td>
        <p-button
          
          type="button"
          icon="pi pi-pencil"
          (click)="edit(treeType)"
          severity="info" >
        </p-button>
        <p-button
          
          type="button"
          icon="pi pi-trash"
          (click)="delete(treeType)"
          severity="danger">
        </p-button>
      </td>
    </tr>
  </ng-template>
</p-table>

<br/>